import { render, staticRenderFns } from "./ScreenOjinCaseDetails.vue?vue&type=template&id=b9d325ce&scoped=true&"
import script from "./ScreenOjinCaseDetails.vue?vue&type=script&lang=js&"
export * from "./ScreenOjinCaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d325ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
